import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { ListerPagination } from '../../components/lister/deprecated/ListerPagination';
import { makeGetContentTotalPages } from '../../redux/content/selectors/ContentSelectors';
export const ContentListerPagination = () => {
    const totalPages = useSelector(makeGetContentTotalPages());
    return _jsx(ListerPagination, { updateCanonicalLinkElement: false, totalPages: totalPages });
};
